// extracted by css-extract-rspack-plugin
export default {"container":"_1f3bcad8","returnPolicyContainer":"_41e08672","icon":"_9745bb54"};